module.exports = __webpack_public_path__ + "static/Graphik-RegularItalic-Cy-Web-eab5768014d1680228ff54d1f6d0f327.woff2";